//inspired by react redux
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch;
export var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
};
export var getBatch = function getBatch() {
  return batch;
};